const t = Symbol("pageBottomContext");
export {
  t as pageBottomContextKey
};
